import { createSlice } from '@reduxjs/toolkit';
import { SESSION_DURATION_DEFAULT } from 'constants/session';
import { RootState } from 'store/root.types';

export const contextSliceName = 'context';

const getInitialState = () => ({
  organization: {
    data: {
      preferences: {
        sessionDuration: SESSION_DURATION_DEFAULT,
      },
    },
  },
});

export const contextSlice = createSlice({
  name: contextSliceName,
  initialState: getInitialState(),
  reducers: {
    reset(state) {
      Object.assign(state, getInitialState());
    },
  },
});

export const { reset } = contextSlice.actions;

export const selectOrganization = (state: RootState) => {
  return state[contextSliceName].organization;
};
